import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Paper } from "@mui/material";

export const StyledDashItem = styled(Paper)`
  background-color: ${({ theme }) => theme.colors.historybk};
  padding: 30px;

  .grid-item-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.textColor};
    font-size: ${({ theme }) => theme.font.large};
    margin-bottom: 20px;
  }

  .grid-item-heading {
    font-size: ${({ theme }) => theme.font.large};
    color: ${({ theme }) => theme.colors.textColor};
  }

  .info-icon {
    color: #e6e6dc;
    width: 12px;
  }

  border-radius: 5px;
`;

// The style for each Column
export const StyledDashColumn = styled.div`
  ${StyledDashItem} {
    margin-top: 1em;
  }
`;

// The Styles for the columns' wrapper
export const StyledDashContainer = styled.div<{ sideModel?: boolean }>`
  display: flex;
  flex-wrap: wrap;

  > div:first-child {
    margin-right: 1em;
  }


  ${({ sideModel }) =>
  sideModel === false
    ? `
      ${StyledDashColumn}:nth-child(1) {
        flex: 0 0 66%;
        max-width: 65%;
      }
    `
    : `
      ${StyledDashColumn}:nth-child(1) {
        flex: 0 0 66%;
        max-width: 100%;
      }
    `}

  ${StyledDashColumn}:nth-child(2) {
    flex: 1;
    max-width: 100%
  }

  

  @media ${deviceSpec.isTablet} {
    flex-direction: column; 
    margin: 0 1em 1em 1em;

    ${StyledDashColumn} {
      flex: 1 !important;
      max-width: 100% !important;
      color: pink;
    }
  }
`;